const { conf } = require('./configService');

const imageProxyService = {
  getCanonicalUrl: imagePath => {
    const path = imagePath
      // Check if imagePath has a domain. Remove next two lines when all JSON data contains only relative paths.
      .replace(/\/sites\/default\/files\//, '/files/') // Needed for ngeo.local.
      .replace(/https?:\/\/[^/]+\/files\//, '/files/')
      .replace('/files/', `https://${conf.staticDomain}/files/`);
    if (conf.isStage) {
      return path.replace('/files/', '/img/');
    }
    return path;
  }
};

module.exports = imageProxyService;
